<div class="simple-banner">
  <div class="mat-title-large simple-banner-title">{{ title() }}</div>
  <div class="mat-body-small">{{ subTitle() }}</div>
</div>
<ng-content />
